import { Lang } from '@app/i18n';

export class ChangeLangValueDto {
    language!: 'pl' | 'en';

    constructor(value: Lang) {
        switch (value) {
            case 'pl-PL': {
                this.language = 'pl';
                break;
            }
            case 'en-EN': {
                this.language = 'en';
                break;
            }
        }
    }
}
